import { useState } from 'react'

interface SponsorWidgetProps {
  prospectId: string;
  goalId: string;
}

export default function SponsorWidget({ prospectId, goalId }: SponsorWidgetProps) {
  const [amount, setAmount] = useState(2500)
  const [mode, setMode] = useState('one_time')
  const [email, setEmail] = useState('')

  const startCheckout = async () => {
    const CORE_API = import.meta.env.VITE_CORE_API_URL || '';
    const res = await fetch(`${CORE_API}/api/v1/checkout/prospect-donate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prospect_id: prospectId, goal_id: goalId, type: mode, amount_cents: Number(amount), email })
    })
    if (!res.ok) return alert('Unable to start checkout')
    const { checkout_url } = await res.json()
    window.location.href = checkout_url
  }

  return (
    <div className="sponsor-widget">
      <label>
        Amount (¢)
        <input type="number" min={100} step={100} value={amount} onChange={(e) => setAmount(Number(e.target.value))} />
      </label>
      <label>
        Email (receipt)
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <div>
        <label>
          <input type="radio" checked={mode === 'one_time'} onChange={() => setMode('one_time')} /> One-time
        </label>
        <label>
          <input type="radio" checked={mode === 'recurring'} onChange={() => setMode('recurring')} /> Monthly
        </label>
      </div>
      <button onClick={startCheckout}>Sponsor now</button>
    </div>
  )
}
